import { Link, Navigate, Outlet } from 'react-router-dom';

import routesPath from '@/shared/constants/routesPath';
import useUserStore from '@/shared/store/user';
import { cn } from '@/shared/utils';

import Logo from '@/components/ui/Logo';

import Footer from './ui/footer';

const AuthLayout = () => {
  const { user } = useUserStore();

  // if logged in, redirect to the Home page
  if (user?.id) {
    return <Navigate to={routesPath.HOME} />;
  }

  return (
    <>
      <nav
        className={cn([
          'fixed left-0 right-0 top-0 z-10',
          'flex min-h-[60px] items-center justify-center',
          'flex-wrap bg-black/50 p-2 backdrop-blur-sm',
          'md:min-h-[84px] md:px-6 md:py-2.5',
          'border-b border-white/20',
        ])}
      >
        <Link to={routesPath.HOME}>
          <Logo />
        </Link>
      </nav>

      <main className="min-h-screen bg-gradient-to-b from-black to-[#2D623B] pt-[60px] md:pt-[84px] text-white pb-[50px]">
        <section className="container max-md:px-4 py-12 min-h-[calc(100vh-157px)] md:min-h-[calc(100vh-149px)]">
          <div
            className={cn([
              'm-auto flex max-w-[1003px] ',
              'items-center rounded-3xl bg-black bg-opacity-30',
              'px-16 pb-12 pt-12 backdrop-blur-[20px] max-md:px-5',
              'relative justify-center lg:px-24',
              'min-h-[673px]',
            ])}
          >
            <Outlet />
          </div>
        </section>

        <div className="w-full">
          <Footer />
        </div>
      </main>
    </>
  );
};

export default AuthLayout;
